import axios from '@axios'

export default {
    namespaced: true,
    state: {
        embarques: [],
        puertos: [],
        datosEmbarques: [],
        rubros: [],
        rubrosall: [],
        current_page: 1,
        last_page: 0,
        per_page: 0,
        total: 0,
        datosEmbarquesSem: [],
        cobranza: [],
        //Exportaciones 2022 - ??
        mercado: [],
        terminoPago: [],
        plazoPago: [],
        formaPago: [],
        bancoPago: [],
        terminoNegociacion: [],
        formaNegociacion: [],
        clienteExterior: [],
        grupoEconomico: [],
        comisionista: [],
        consignatario: [],
        notificador: [],
        facturador: [],
        recibero: [],
        contactoComercial: [],
        usaagent: [],
        broker: [],
        //Exportaciones 2022 - ??
        tipoPuertos: [],
        tipoMercado: [],
        tipoAgenciasNavieras: [],
        tipoLineasNavieras: [],
        buque: [],
        contenedor: [],
        tiposPuertos: [],
        tiposConceptos: [],
        tarifaNaviera: [],
        fichaClienteLineaNaviera: [],
        segmento: [],
        tipoFechaTarifa: [],
        vehiculos: [],
        factura: [],
        datosSecuencial: [],
        terminalEmbarque: [],
        embarqueDet: [],
        embarqueDetId: [],
        tipoEmbarque: [],
        entidadesXcategoria: [],
        transportadoras: [],
        firmasDocumentos: [],
        tiposVehiculo: [],
        conductores: [],
        pesoBruto: [],
        aseguradoras: [],
        plantasRelacionadas: [],
        datosExportacion: [],
        regimen: [],
        mercadosAll: [],
        puertosAll: [],
        buquesAll: [],
        segmentosAll: [],
        agenciaNavieraAll: [],
        lineaNavieraAll: [],
        tipoContenedorAll: [],
        terminalEmbarqueAll: [],
        transportadorasAll: [],
        pesoBrutoAll: [],
        tiposVehiculosAll: [],
        vehiculosAll: [],
        conductoresAll: [],
        tipoJefesPlanta: [],
        jefePlantaAll: [],
        paisesSRI: [],
        ciudadesProvXpais: [],
        embarqueSemana: [],
        tiposRoleo: [],
        //embarqueBooking:[],
        bookingEstado: [],
        bookingDetalle: [],
        // embarqueSemana: [],
        jefePlantaxEstab: [],
        embarquesAprobados: [],
        entidadesXcategoriaV2: [],
        conceptosTarifas: [],
        // Tipo Concepto
        all_tipo_concepto: [],
        tipo_concepto: [],
        tipoAerolineas: [],
        // Tipo Concepto
        //Facturas Comerciales
        facturasComerciales: [],
        // Facturas Fiscales
        facturasComercialesAprobadas: [],
        // Facturas Fiscales
        facturasFiscales: [],
        // Peso Bruto
        facturasPesoBrutoSSR: [],
        // DistritoAduanero
        allDistritoAduanero: [],
        distritoAduanero: [],
        // DistritoAduanero
        tipoDescuentos: [],
        embarqueXestado: [],
        tipoAnticipos: [],
        tipoExcedentes: [],
        // embarqueXestado: [],
        ciudadesXpuerto: [],
        motivoNC: [],
        motivoND: [],
        // Certificados Exportacion
        certificadosExportacion: [],
        facturasComercialesSSR: [],
        facturasComercialesCert: [],
        // Certificados Exportacion
        // Dashboard Ventas
        dashboardsVentas: [],
        consultaEmbarque: [],
        consultaSaldosClientes: [],
        // Dashboard Ventas
        estadoTablaPlanificacionBooking: [],
        librasDetalladasFC: [],
        // Documento
        allDocumento: [],
        // Documento
        // InfiniteScrollPaises
        infiniteScrollPaises: [],
        // InfiniteScrollPaises
        // UsersByCompanyAplication
        usersByCompanyAplication: [],
        // UsersByCompanyAplication
        // Courier
        allCourier: [],
        courier: [],
        // Courier
        //Monitor Embarque
        monitorEmbarque: [],
        //Monitor Documentacion
        monitorDocumentacion: [],
        facturasXdocumentar: [],
        facturasDocumentacion: [],
        consignatariosXcliente: [],
        //Contrato
        paginationContratos: [],
        contratos: [],
        contrato: [],
        //Contrato
        // FichaClienteExterior
        allFichaClienteExterior: [],
        // FichaClienteExterior
        totalExportacionAnual: [],
        //Monitor Contenedores
        monitorContenedores: [],
        detalleContenedores: [],
        //Monitor Ordenes pedido
        monitorOrdenesPedido: [],
        detallePrecioFinca: [],
        monitorOrdenesPedidoFc: [],
        detallePrecioFincaFc: [],
        proformaDetallePrecioFinca: [],
        //YearToYear
        yearToYear: [],
        //PrecioPorSemana
        precioPorSemana: [],
        sectores: [],
        sectoresXmercado: [],
        tipoContrato: [],
        //PrecioRetornoFinca
        precioRetornoFinca: []
    },
    getters: {
        getEmbarqueSemana(state) {
            return state.embarqueSemana
        },
        getEmbarqueTarifa(state) {
            return state.embarqueTarifa
        },
        getLineasNavieras(state) {
            return state.tipoLineasNavieras
        },
        getPuertos(state) {
            return state.puertos
        },
        getRubros(state) {
            return state.rubros
        },
        getRubrosAll(state) {
            return state.rubrosall
        },
        getEmbarques(state) {
            return state.embarques
        },
        getDatosEmbarque(state) {
            return state.datosEmbarque
        },
        getTipoPuertos(state) {
            return state.tiposPuertos
        },
        //Exportaciones 2022 - ??
        getMercados(state) {
            return state.tipoMercado
        },
        getMercadosAll(state) {
            return state.mercadosAll
        },
        getTerminosPago(state) {
            return state.terminoPago
        },
        getPlazosPago(state) {
            return state.plazoPago
        },
        getFormasPago(state) {
            return state.formaPago
        },
        getBancosPago(state) {
            return state.bancoPago
        },
        getTerminoNegociacion(state) {
            return state.terminoNegociacion
        },
        getFormaNegociacion(state) {
            return state.formaNegociacion
        },
        getClientesExterior(state) {
            return state.clienteExterior
        },
        getGrupoEconomico(state) {
            return state.grupoEconomico
        },
        getComisionistas(state) {
            return state.comisionista
        },
        getConsignatarios(state) {
            return state.consignatario
        },
        getConsignatariosXcliente(state) {
            return state.consignatariosXcliente
        },
        getNotificadores(state) {
            return state.notificador
        },
        getFacturadores(state) {
            return state.facturador
        },
        getReciberos(state) {
            return state.recibero
        },
        getContactoComercial(state) {
            return state.contactoComercial
        },
        getUsaAgent(state) {
            return state.usaagent
        },
        getBroker(state) {
            return state.broker
        },
        getTipoDescuentos(state) {
            return state.tipoDescuentos
        },
        getTipoAnticipos(state) {
            return state.tipoAnticipos
        },
        getTipoExcedentes(state) {
            return state.tipoExcedentes
        },
        //Exportaciones 2022 - ??
        getTipoAgenciasNavieras(state) {
            return state.tipoAgenciasNavieras
        },
        getTipoAerolineas(state) {
            return state.tipoAerolineas
        },
        getBuque(state) {
            return state.buque
        },
        getContenedor(state) {
            return state.contenedor
        },
        getTiposConceptos(state) {
            return state.tiposConceptos
        },
        getConsultaTarifaNaviera(state) {
            return state.tarifaNaviera
        },
        getfichaClienteLineaNaviera(state) {
            return state.fichaClienteLineaNaviera
        },
        getSegmento(state) {
            return state.segmento
        },
        getTiposFechaTarifa(state) {
            return state.tipoFechaTarifa
        },
        getVehiculos(state) {
            return state.vehiculos
        },
        getFacturaExportaciones(state) {
            return state.factura
        },
        getDatosSecuencial(state) {
            return state.datosSecuencial
        },

        getEmbarqueDet(state) {
            return state.embarqueDet
        },
        getEmbarqueDetId(state) {
            return state.embarqueDetId
        },
        getTipoEmbarque(state) {
            return state.tipoEmbarque
        },
        getTipoContrato(state) {
            return state.tipoContrato
        },
        getTerminalEmbarque(state) {
            return state.terminalEmbarque
        },
        // getEmbarqueDet(state) {
        //     return state.embarqueDet
        // },
        // getEmbarqueDetId(state) {
        //     return state.embarqueDetId
        // },

        getEntidadesXcategoria(state) {
            return state.entidadesXcategoria
        },
        getEntidadesXcategoriaV2(state) {
            return state.entidadesXcategoriaV2
        },
        getTransportadoras(state) {
            return state.transportadoras
        },
        getAllFirmasDocumentos(state) {
            return state.firmasDocumentos
        },
        getTiposVehiculo(state) {
            return state.tiposVehiculo
        },
        getConductores(state) {
            return state.conductores
        },
        getPesobruto(state) {
            return state.pesoBruto
        },
        getAseguradoras(state) {
            return state.aseguradoras.map(e => {
                return {
                    id_aseguradora: e.id_aseguradora,
                    nombre: e.persona.razon_social,
                    tasa: e.porcentaje_tasa,
                    total_aproximado: e.total_aproximado,
                }
            })
        },
        getPlantasRelacionadas(state) {
            return state.plantasRelacionadas
        },
        getDatosExportacion(state) {
            return state.datosExportacion
        },
        getTiposRegimen(state) {
            return state.regimen
        },
        // getDatosExportacion(state) {
        //     return state.datosExportacion
        // },
        // getTiposRegimen(state) {
        //     return state.regimen
        // },
        getPuertosAll(state) {
            return state.puertosAll
        },
        getBuquesAll(state) {
            return state.buquesAll
        },
        getSegmentoAll(state) {
            return state.segmentosAll
        },
        getAgenciaNavieraAll(state) {
            return state.agenciaNavieraAll
        },
        getLineaNavieraAll(state) {
            return state.lineaNavieraAll
        },
        getTipoContenedorAll(state) {
            return state.tipoContenedorAll
        },
        getTerminalEmbarqueAll(state) {
            return state.terminalEmbarqueAll
        },
        getTransportadorasAll(state) {
            return state.transportadorasAll
        },
        getPesobrutoAll(state) {
            return state.pesoBrutoAll
        },
        getTiposVehiculoAll(state) {
            return state.tiposVehiculosAll
        },
        getVehiculosAll(state) {
            return state.vehiculosAll
        },
        getConductoresAll(state) {
            return state.conductoresAll
        },
        getJefesPlanta(state) {
            return state.tipoJefesPlanta
        },
        getJefePlantaAll(state) {
            return state.jefePlantaAll
        },
        getPaisesSRI(state) {
            return state.paisesSRI
        },
        getCiudadesProvXpais(state) {
            return state.ciudadesProvXpais
        },
        getTiposRoleo(state) {
            return state.tiposRoleo
        },
        // getEmbarqueBooking(state){
        //     return state.embarqueBooking;
        // },
        getBookingEstado(state) {
            return state.bookingEstado
        },
        getBookingDetalle(state) {
            return state.bookingDetalle
        },
        getEmbarquesAprobados(state) {
            return state.embarquesAprobados
        },
        getAllConceptoTarifa(state) {
            return state.conceptosTarifas
        },
        // Tipo Concepto
        getAllTipoConcepto(state) {
            return state.all_tipo_concepto
        },
        getTipoConcepto(state) {
            return state.tipo_concepto
        },
        getTerminalEmbXPuerto(state) {
            return state.terminalEmbXPuerto
        },
        getEmbarqueXestado(state) {
            return state.embarqueXestado
        },
        getJefePlantaxEstab(state) {
            return state.jefePlantaxEstab
        },
        // Tipo Concepto
        // Factura Comercial
        getFacturasComerciales(state) {
            return state.facturasComerciales
        },
        // Factura Fiscal
        getFacturasComercialesAprobadas(state) {
            return state.facturasComercialesAprobadas
        },
        // Factura Fiscal
        getFacturasFiscales(state) {
            return state.facturasFiscales
        },
        // DistritoAduanero
        getDistritoAduanero(state) {
            return state.distritoAduanero
        },
        getAllDistritoAduanero(state) {
            return state.allDistritoAduanero
        },
        // getEmbarqueXestado(state) {
        //     return state.embarqueXestado
        // },
        // DistritoAduanero
        getCiudadesXPuerto(state) {
            return state.ciudadesXpuerto
        },
        getMotivoNC(state) {
            return state.motivoNC
        },
        getMotivoND(state) {
            return state.motivoND
        },
        // Certificados Exportacion
        getCertificadosExportacion(state) {
            return state.certificadosExportacion
        },
        // Certificados Exportacion
        // Dashboard Ventas
        getDashboardsVentas(state) {
            return state.dashboardsVentas
        },
        getConsultaEmbarque(state) {
            return state.consultaEmbarque
        },
        getConsultaSaldosClientes(state) {
            return state.consultaSaldosClientes
        },
        // Dashboard Ventas
        getEstadoTablaPlanificacionBooking(state) {
            return state.estadoTablaPlanificacionBooking
        },
        getLibrasDetalladasFC(state) {
            return state.librasDetalladasFC
        },
        // Documento
        getAllDocumento(state) {
            return state.allDocumento
        },
        // Documento
        // InfiniteScrollPaises
        getInfiniteScrollPaises(state) {
            return state.infiniteScrollPaises
        },
        // InfiniteScrollPaises
        // UsersByCompanyAplication
        getUsersByCompanyAplication(state) {
            return state.usersByCompanyAplication
        },
        // UsersByCompanyAplication
        // Courier
        getCourier(state) {
            return state.courier
        },
        getAllCourier(state) {
            return state.allCourier
        },
        // Courier
        // Monitor Embarque
        getMonitorEmbarque(state) {
            return state.monitorEmbarque
        },
        // Monitor Documentacion
        getMonitorDocumentacion(state) {
            return state.monitorDocumentacion
        },
        getFacturasXdocumentar(state) {
            return state.facturasXdocumentar
        },
        getFacturasDocumentacion(state) {
            return state.facturasDocumentacion
        },
        //Contrato
        getPaginationContratos(state) {
            return state.paginationContratos
        },
        getContratos(state) {
            return state.contratos
        },
        // getContrato(state) {
        //     return state.contrato
        // },
        //Contrato
        // FichaClienteExterior
        getAllFichaClienteExterior(state) {
            return state.allFichaClienteExterior
        },
        // FichaClienteExterior
        getTotalExportacionAnual(state) {
            return state.totalExportacionAnual
        },
        //Monitor Contenedores
        getMonitorContenedores(state) {
            return state.monitorContenedores
        },
        getDetalleContenedores(state) {
            return state.detalleContenedores
        },
        //Monitor Ordenes Pedido
        getMonitorOrdenesPedido(state) {
            return state.monitorOrdenesPedido
        },
        getDetallePrecioFinca(state) {
            return state.detallePrecioFinca
        },
        getMonitorOrdenesPedidoFc(state) {
            return state.monitorOrdenesPedidoFc
        },
        getDetallePrecioFincaFc(state) {
            return state.detallePrecioFincaFc
        },
        getProformaDetallePrecioFinca(state) {
            return state.proformaDetallePrecioFinca
        },
        // YearToYear
        getYearToYear(state) {
            return state.yearToYear
        },
        // PrecioPorSemana
        getPrecioPorSemana(state) {
            return state.precioPorSemana
        },
        getSectores(state) {
            return state.sectores
        },
        getSectoresXmercado(state) {
            return state.sectoresXmercado
        },
        //Precio retorno finca
        getPrecioRetornoFinca(state) {
            return state.precioRetornoFinca
        },
    },
    mutations: {
        setJefePlantaxEstab(state, jefePlantaEstab) {
            state.jefePlantaEstab = jefePlantaEstab
        },
        setEmbarqueXTarifa(state, embarqueTarifa) {
            state.embarqueTarifa = embarqueTarifa
        },
        setEmbarqueXSemana(state, embarqueSemana) {
            state.embarqueSemana = embarqueSemana
        },
        setEmbarques(state, embarques) {
            state.embarques = embarques
        },
        setDatosEmbarques(state, datosEmbarques) {
            state.datosEmbarques = datosEmbarques
        },
        setPuertos(state, puertos) {
            state.puertos = puertos
        },
        setRubros(state, rubros) {
            state.rubros = rubros
        },
        setRubrosAll(state, rubrosall) {
            state.rubros = rubrosall
        },
        setTipoPuertos(state, tipoPuertos) {
            state.tiposPuertos = tipoPuertos
        },
        setTipoMercados(state, tipoMercado) {
            state.tipoMercado = tipoMercado
        },
        setMercadosAll(state, mercadosAll) {
            state.mercadosAll = mercadosAll
        },
        setTotalEmbarque(state, data) {
            var embarque = state.embarques.rubros.find(
                e => e.id_rubro === data.id_rubro && e.co_muelle === data.co_muelle
            )
            embarque.total = data.total
        },
        setDatosEmbarquesSem(state, datosEmbarquesSem) {
            state.datosEmbarquesSem = datosEmbarquesSem
        },
        setTipoAgenciaNaviera(state, tipoAgenciasNavieras) {
            state.tipoAgenciasNavieras = tipoAgenciasNavieras
        },
        setTipoAerolineas(state, tipoAerolineas) {
            state.tipoAerolineas = tipoAerolineas
        },
        setTipoLineaNaviera(state, tipoLineasNavieras) {
            state.tipoLineasNavieras = tipoLineasNavieras
        },
        setMercados(state, mercado) {
            state.mercado = mercado
        },
        setTipoBuque(state, buque) {
            state.buque = buque
        },
        setTipoContrato(state, tipoContrato) {
            state.tipoContrato = tipoContrato
        },
        setTipoContenedor(state, contenedor) {
            state.contenedor = contenedor
        },
        setTipoTerminalEmbarque(state, terminalEmbarque) {
            state.terminalEmbarque = terminalEmbarque
            state.terminalEmbarque = terminalEmbarque
            state.terminalEmbarque = terminalEmbarque
        },
        setTiposConceptos(state, tiposConceptos) {
            state.tiposConceptos = tiposConceptos
        },
        // Exportaciones 2022 - ??
        setTerminoPago(state, terminoPago) {
            state.terminoPago = terminoPago
        },
        setPlazoPago(state, plazoPago) {
            state.plazoPago = plazoPago
        },
        setFormaPago(state, formaPago) {
            state.formaPago = formaPago
        },
        setBancoPago(state, bancoPago) {
            state.bancoPago = bancoPago
        },
        setTerminoNegociacion(state, terminoNegociacion) {
            state.terminoNegociacion = terminoNegociacion
        },
        setFormaNegociacion(state, formaNegociacion) {
            state.formaNegociacion = formaNegociacion
        },
        setClienteExterior(state, clienteExterior) {
            state.clienteExterior = clienteExterior
        },
        setGrupoEconomico(state, grupoEconomico) {
            state.grupoEconomico = grupoEconomico
        },
        setComisionista(state, comisionista) {
            state.comisionista = comisionista
        },
        setConsignatario(state, comisionista) {
            state.comisionista = comisionista
        },
        setConsignatariosXcliente(state, consignatariosXcliente) {
            state.consignatariosXcliente = consignatariosXcliente
        },
        setNotificador(state, comisionista) {
            state.comisionista = comisionista
        },
        setFacturador(state, comisionista) {
            state.comisionista = comisionista
        },
        setRecibero(state, recibero) {
            state.recibero = recibero
        },
        setContactoComercial(state, contactoComercial) {
            state.contactoComercial = contactoComercial
        },
        setUsaAgent(state, usaagent) {
            state.usaagent = usaagent
        },
        setBroker(state, broker) {
            state.broker = broker
        },
        setTipoAnticipo(state, tipoAnticipos) {
            state.tipoAnticipos = tipoAnticipos
        },
        setTipoExcedente(state, tipoExcedentes) {
            state.tipoExcedentes = tipoExcedentes
        },
        setTipoDescuento(state, tipoDescuentos) {
            state.tipoDescuentos = tipoDescuentos
        },
        setConsultaTarifaNaviera(state, tarifaNaviera) {
            state.tarifaNaviera = tarifaNaviera
        },
        setfichaClienteLineaNaviera(state, fichaClienteLineaNaviera) {
            state.fichaClienteLineaNaviera = fichaClienteLineaNaviera
        },

        //Exportaciones 2022 - ??

        setSegmento(state, segmento) {
            state.segmento = segmento
        },

        setTipoFechaTarifa(state, tipoFechaTarifa) {
            state.tipoFechaTarifa = tipoFechaTarifa
        },
        setVehiculos(state, vehiculos) {
            state.vehiculos = vehiculos
        },
        setFactura(state, factura) {
            state.factura = factura
        },
        setEmbarqueDet(state, embarqueDet) {
            state.embarqueDet = embarqueDet
        },
        setEmbarqueDetId(state, embarqueDetId) {
            state.embarqueDetId = embarqueDetId
        },
        setDatosSecuencial(state, datosSecuencial) {
            state.datosSecuencial = datosSecuencial
        },
        setConsultaEmbarque(state, consultaEmbarque) {
            state.consultaEmbarque = consultaEmbarque
        },
        setConsultaSaldosClientes(state, consultaSaldosClientes) {
            state.consultaSaldosClientes = consultaSaldosClientes
        },
        setTransportadoras(state, transportadoras) {
            state.transportadoras = transportadoras
        },

        setTiposVehiculo(state, tiposVehiculo) {
            state.tiposVehiculo = tiposVehiculo
        },
        setTipoEmbarque(state, tipoEmbarque) {
            state.tipoEmbarque = tipoEmbarque
        },
        setConductores(state, conductores) {
            state.conductores = conductores
        },
        setAllFirmasDocumentos(state, firmasDocumentos) {
            state.firmasDocumentos = firmasDocumentos
        },
        setPesoBruto(state, pesoBruto) {
            state.pesoBruto = pesoBruto
        },
        setAseguradoras(state, aseguradoras) {
            state.aseguradoras = aseguradoras
        },
        setPlantasRelacionadas(state, plantasRelacionadas) {
            state.plantasRelacionadas = plantasRelacionadas
        },
        setDatosExportacion(state, datosExportacion) {
            state.datosExportacion = datosExportacion
        },
        setTipoRegimen(state, regimen) {
            state.regimen = regimen
        },
        setPuertosAll(state, puertosAll) {
            state.puertosAll = puertosAll
        },
        setBuquesAll(state, buquesAll) {
            state.buquesAll = buquesAll
        },
        setSegmentosAll(state, segmentosAll) {
            state.segmentosAll = segmentosAll
        },
        setAgenciaNavieraAll(state, agenciaNavieraAll) {
            state.agenciaNavieraAll = agenciaNavieraAll
        },
        setLineaNavieraAll(state, lineaNavieraAll) {
            state.lineaNavieraAll = lineaNavieraAll
        },
        setJefePlantaAll(state, jefePlantaAll) {
            state.jefePlantaAll = jefePlantaAll
        },
        setTipoContenedorAll(state, tipoContenedorAll) {
            state.tipoContenedorAll = tipoContenedorAll
        },
        setTerminalEmbarqueAll(state, terminalEmbarqueAll) {
            state.terminalEmbarqueAll = terminalEmbarqueAll
        },
        setTransportadorasAll(state, transportadorasAll) {
            state.transportadorasAll = transportadorasAll
        },
        setPesoBrutoAll(state, pesoBrutoAll) {
            state.pesoBrutoAll = pesoBrutoAll
        },
        setTiposVehiculoAll(state, tiposVehiculosAll) {
            state.tiposVehiculosAll = tiposVehiculosAll
        },
        setVehiculosAll(state, vehiculosAll) {
            state.vehiculosAll = vehiculosAll
        },
        setConductoresAll(state, conductoresAll) {
            state.conductoresAll = conductoresAll
        },
        setTipoJefePlanta(state, tipoJefesPlanta) {
            state.tipoJefesPlanta = tipoJefesPlanta
        },
        setPaisesSRI(state, paisesSRI) {
            state.paisesSRI = paisesSRI
        },
        setCiudadesProvXpais(state, ciudadesProvXpais) {
            state.ciudadesProvXpais = ciudadesProvXpais
        },
        setAllConceptoTarifa(state, conceptosTarifas) {
            state.conceptosTarifas = conceptosTarifas
        },
        setTipoRoleo(state, tiposRoleo) {
            state.tiposRoleo = tiposRoleo
        },
        setEmbarquesAprobados(state, embarquesAprobados) {
            state.embarquesAprobados = embarquesAprobados
        },
        // setEmbarqueBooking(state,embarqueBooking){
        //     state.embarqueBooking=embarqueBooking
        // },
        setBookingEstado(state, bookingEstado) {
            state.bookingEstado = bookingEstado
        },
        setBookingDetalle(state, bookingDetalle) {
            state.bookingDetalle = bookingDetalle
        },
        setTerminalEmbXpuerto(state, terminalEmbXPuerto) {
            state.terminalEmbXPuerto = terminalEmbXPuerto
        },
        setEmbarqueXestado(state, embarqueXestado) {
            state.embarqueXestado = embarqueXestado
        },
        // Tipo Concepto
        // Factura Comercial
        setFacturasComerciales(state, facturasComerciales) {
            state.facturasComerciales = facturasComerciales
        },
        // Factura Fiscal
        setFacturasComercialesAprobadas(state, facturasComercialesAprobadas) {
            state.facturasComercialesAprobadas = facturasComercialesAprobadas
        },
        // Factura Fiscal
        setFacturasFiscales(state, facturasFiscales) {
            state.facturasFiscales = facturasFiscales
        },
        //Peso bruto
        setFacturasPesoBrutoSSR(state, facturasPesoBrutoSSR) {
            state.facturasPesoBrutoSSR = facturasPesoBrutoSSR
        },
        // DistritoAduanero
        setAllDistritoAduanero(state, allDistritoAduanero) {
            state.allDistritoAduanero = allDistritoAduanero
        },
        setDistritoAduanero(state, distritoAduanero) {
            state.distritoAduanero = distritoAduanero
        },
        // setEmbarqueXestado(state, embarqueXestado) {
        //     state.embarqueXestado = embarqueXestado
        // },
        // DistritoAduanero
        setEntidadesXcategoria(state, entidadesXcategoria) {
            state.entidadesXcategoria = entidadesXcategoria
        },
        setEntidadesXcategoriaV2(state, entidadesXcategoriaV2) {
            state.entidadesXcategoriaV2 = entidadesXcategoriaV2
        },
        setTipoConcepto(state, tipo_concepto) {
            state.tipo_concepto = tipo_concepto
        },
        setCiudadesXPuerto(state, ciudadesXpuerto) {
            state.ciudadesXpuerto = ciudadesXpuerto
        },
        setMotivoNC(state, motivoNC) {
            state.motivoNC = motivoNC
        },
        setMotivoND(state, motivoND) {
            state.motivoND = motivoND
        },
        // Certificados Expotacion
        setCertificadosExportacion(state, certificadosExportacion) {
            state.certificadosExportacion = certificadosExportacion
        },
        setFacturasComercialesSSR(state, facturasComercialesSSR) {
            state.facturasComercialesSSR = facturasComercialesSSR
        },
        setFacturasComercialesCert(state, facturasComercialesCert) {
            state.facturasComercialesCert = facturasComercialesCert
        },
        // Certificados Expotacion
        // Dashboard Ventas
        setDashboardsVentas(state, dashboardsVentas) {
            state.dashboardsVentas = dashboardsVentas
        },
        // Dashboard Ventas
        setEstadoTablaPlanificacionBooking(state, data) {
            state.estadoTablaPlanificacionBooking = data
        },
        setLibrasDetalladasFC(state, librasDetalladasFC) {
            state.librasDetalladasFC = librasDetalladasFC
        },
        // Documento
        setAllDocumento(state, allDocumento) {
            state.allDocumento = allDocumento
        },
        // Documento
        // InfiniteScrollPaises
        setInfiniteScrollPaises(state, infiniteScrollPaises) {
            state.infiniteScrollPaises = infiniteScrollPaises
        },
        // InfiniteScrollPaises
        // UsersByCompanyAplication
        setUsersByCompanyAplication(state, usersByCompanyAplication) {
            state.usersByCompanyAplication = usersByCompanyAplication
        },
        // UsersByCompanyAplication
        // Courier
        setAllCourier(state, allCourier) {
            state.allCourier = allCourier
        },
        setCourier(state, courier) {
            state.courier = courier
        },
        // Courier
        // Monitor Embarque
        setMonitorEmbarque(state, monitorEmbarque) {
            state.monitorEmbarque = monitorEmbarque
        },
        // Monitor Documentacion
        setMonitorDocumentacion(state, monitorDocumentacion) {
            state.monitorDocumentacion = monitorDocumentacion
        },
        setFacturasXdocumentar(state, facturasXdocumentar) {
            state.facturasXdocumentar = facturasXdocumentar
        },
        setFacturasDocumentacion(state, facturasDocumentacion) {
            state.facturasDocumentacion = facturasDocumentacion
        },
        //Contrato
        setPaginationContratos(state, paginationContratos) {
            state.paginationContratos = paginationContratos
        },
        setContratos(state, contratos) {
            state.contratos = contratos
        },
        setContrato(state, contrato) {
            state.contrato = contrato
        },
        //Contrato
        // FichaClienteExterior
        setAllFichaClienteExterior(state, allFichaClienteExterior) {
            state.allFichaClienteExterior = allFichaClienteExterior
        },
        // FichaClienteExterior
        setTotalExportacionAnual(state, totalExportacionAnual) {
            state.totalExportacionAnual = totalExportacionAnual
        },
        // Monitor Contenedores
        setMonitorContenedores(state, monitorContenedores) {
            state.monitorContenedores = monitorContenedores
        },
        setDetalleContenedores(state, detalleContenedores) {
            state.detalleContenedores = detalleContenedores
        },
        setMonitorOrdenesPedido(state, monitorOrdenesPedido) {
            state.monitorOrdenesPedido = monitorOrdenesPedido
        },
        setDetallePrecioFinca(state, detallePrecioFinca) {
            state.detallePrecioFinca = detallePrecioFinca
        },
        setMonitorOrdenesPedidoFc(state, monitorOrdenesPedidoFc) {
            state.monitorOrdenesPedidoFc = monitorOrdenesPedidoFc
        },
        setDetallePrecioFincaFc(state, detallePrecioFincaFc) {
            state.detallePrecioFincaFc = detallePrecioFincaFc
        },
        setProformaDetallePrecioFinca(state, proformaDetallePrecioFinca) {
            state.proformaDetallePrecioFinca = proformaDetallePrecioFinca
        },
        // YearToYear
        setYearToYear(state, yearToYear) {
            state.yearToYear = yearToYear
        },
        setPrecioPorSemana(state, precioPorSemana) {
            state.precioPorSemana = precioPorSemana
        },
        setSectores(state, sectores) {
            state.sectores = sectores
        },
        setSectoresXmercado(state, sectoresXmercado) {
            state.sectoresXmercado = sectoresXmercado
        },
        //Precio retorno finca
        setPrecioRetornoFinca(state, precioRetornoFinca) {
            state.precioRetornoFinca = precioRetornoFinca
        },
    },
    actions: {
        fetchBookingEstado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/bookingEstado', { params: data })
                    .then(response => {
                        commit('setBookingEstado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDatoLogEmbarque(_a, id_res_emb_det) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/logEmbarqueId/${id_res_emb_det}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchBookingDetalleId(_a, id_booking_detalle) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/bookingDetalleId/${id_booking_detalle}`)
                    .then(response => {
                        //commit('setEmbarqueDetId', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reporteEmbarqueSalem', data, { responseType: 'arraybuffer' })
                    .then(response => {
                        //commit('setReporteEmbarqueSalem', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteSaldoCliente(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reporteSaldoCliente', data, { responseType: 'arraybuffer' })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // fetchEmbarqueBooking(_a, data){
        //     return new Promise((resolve, reject) => {
        //         axios.get('/api/auth/exportaciones/embarqueBooking', { params: data })
        //             .then((response) => {
        //                 commit('setEmbarqueBooking', response.data)
        //                 resolve(response)

        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             })
        //     })

        // },
        fechtUpdateEmbarqueDatos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateEmbarqueDatos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // fetchReversarEmbarque(_a, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/exportaciones/reversarEmbarque', data)
        //             .then(response => {
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        fetchReversarEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reversarEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtUpdateEmbarqueP(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateEmbarqueP', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmbarqueXSemana({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/embarqueXSemana', { params: data })
                    .then(response => {
                        commit('setEmbarqueXSemana', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmbarqueXTarifa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/embarqueXTarifa', { params: data })
                    .then(response => {
                        commit('setEmbarqueXTarifa', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDataRoleo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateRoleoData', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnularRoleo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateAnularRoleo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDataRoleoMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateRoleoMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDatosExportaciones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/datosExportacion', { params: data })
                    .then(response => {
                        commit('setDatosExportacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoEmbarque({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoEmbarque')
                    .then(response => {
                        commit('setTipoEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoRoleo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoRoleo')
                    .then(response => {
                        commit('setTipoRoleo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaEmbarque', { params: data })
                    .then(response => {
                        commit('setConsultaEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarSaldosClientes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaSaldosClientes', { params: data })
                    .then(response => {
                        commit('setConsultaSaldosClientes', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDetallesSaldosClientes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaDetalleSaldosClientes', { params: data })
                    .then(response => {
                        commit('setConsultaSaldosClientes', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmbarqueDetalleId({ commit }, id_res_emb_det) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/embarqueDetalleId/${id_res_emb_det}`)
                    .then(response => {
                        commit('setEmbarqueDetId', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEmbarqueDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/embarqueDetalle', { params: data })
                    .then(response => {
                        commit('setEmbarqueDet', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtDataSecuencial({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/datosSecuencial', { params: data })
                    .then(response => {
                        commit('setDatosSecuencial', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtBookingDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/bookingDetalle', { params: data })
                    .then(response => {
                        commit('setBookingDetalle', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroSecuencial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/saveSecuencialEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/editar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultaTarifaNaviera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaTarifaNaviera', {
                        params: data,
                    })
                    .then(response => {
                        commit('setConsultaTarifaNaviera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultaEmbarqueXTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaEmbarqueXTarifa', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setConsultaTarifaNaviera", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmbarques({ commit }, co_factura) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/exportaciones/embarques?co_factura=${co_factura}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setEmbarques', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDatosEmbarques({ commit }, co_factura) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/exportaciones/embarque?co_factura=${co_factura}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setDatosEmbarques', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPuertos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/puertos')
                    .then(response => {
                        commit('setPuertos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRubro({ commit }, rubro_id) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/exportaciones/rubro?rubro_id=${rubro_id}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setRubros', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRubros({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/rubros')
                    .then(response => {
                        commit('setRubrosAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchActualizarSecuenciales(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getDatosSecuenciales', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoTerminalEmbarque({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoTerminalEmbarque')
                    .then(response => {
                        commit('setTipoTerminalEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoRegimen({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tiposRegimen')
                    .then(response => {
                        commit('setTipoRegimen', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTerminalEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createTerminalEmbarque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTerminalEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateTerminalEmbarque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTerminalEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeTerminalEmbarque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTarifaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeTarifaNaviera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoContenedor({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoContenedor')
                    .then(response => {
                        commit('setTipoContenedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateContenedor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createContenedor', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateContenedor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateContenedor', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveContenedor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeContenedor', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoBuque({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoBuque')
                    .then(response => {
                        commit('setTipoBuque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoContrato({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoContrato')
                    .then(response => {
                        commit('setTipoContrato', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateContrato(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createContrato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateContrato(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateContrato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /* fetchTipoBuque({commit}){
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/exportaciones/tipoBuque")
                    .then((response) => {
                        commit('', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        }, */
        fetchRemoveContrato(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeContrato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateBuque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createBuque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateBuque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateBuque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveBuque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeBuque', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoLineaNavieras({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoLineaNaviera')
                    .then(response => {
                        commit('setTipoLineaNaviera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateLineaNavieras(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createLineaNaviera', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateLineaNavieras(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateLineaNaviera', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveLineaNavieras(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeLineaNaviera', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoAgenciaNaviera({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoAgenciaNaviera')
                    .then(response => {
                        commit('setTipoAgenciaNaviera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoAerolinea({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoAerolineas')
                    .then(response => {
                        commit('setTipoAerolineas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // fetchAerolinea({ commit }){
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get("/api/auth/exportaciones/tipoAerolinea")
        //             .then((response) => {
        //                 commit("setTipoAerolinea", response.data);
        //                 resolve(response);
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             });
        //     });

        // },
        fetchCreateAgenciaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createAgenciaNaviera', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoJefePlanta({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoJefePlanta')
                    .then(response => {
                        commit('setTipoJefePlanta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateAgenciaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateAgenciaNaviera', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveAgenciaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeAgenciaNaviera', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoPuertos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoPuertos')
                    .then(response => {
                        commit('setTipoPuertos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePuertos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createPuertos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePuertos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updatePuertos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemovePuertos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removePuertos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoMercados({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoMercados')
                    .then(response => {
                        commit('setTipoMercados', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMercadosAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mercadosAll')
                    .then(response => {
                        commit('setMercadosAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTerminalEmbXPuertos({ commit }, id_puerto) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/terminalEmb/${id_puerto}`)
                    .then(response => {
                        commit('setTerminalEmbXpuerto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmbarqueXestado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/embarqueEstado', { params: data })
                    .then(response => {
                        commit('setEmbarqueXestado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchJefePlantaXEstab({ commit }, id_establecimiento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/jefeEstab/${id_establecimiento}`)
                    .then(response => {
                        commit('setJefePlantaxEstab', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateMercados(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createMercados', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateMercados(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateMercados', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveMercados(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeMercados', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        clearRubros({ commit }) {
            commit('setRubros', [])
        },

        postAgregarRubro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/agregarRubro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postA27t48(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/agregarA27T48', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        cambioValorEmbarque({ commit }, data) {
            commit('setTotalEmbarque', data)
        },

        fetchDatosEmbarquesSem({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/exportaciones/embarqueSem?datos=${data.anio}&&semana=${data.semana}`
                axios
                    .get(url)
                    .then(response => {
                        commit('setDatosEmbarquesSem', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postObtenerProforma(_a, data) {
            return new Promise((resolve, reject) => {
                // axios.post('/api/auth/legal/obtenerRegistroMercantil', data)
                // var link = '/api/auth/almacenDocumentos/descargarDocumento'
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/obtenerproforma',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postObtenerFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/obtenerFactura',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postObtenerCertificadoFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/obtenerCertificadoFactura',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postObtenerProformaOtros(_a, data) {
            return new Promise((resolve, reject) => {
                // axios.post('/api/auth/legal/obtenerRegistroMercantil', data)
                // var link = '/api/auth/almacenDocumentos/descargarDocumento'
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/obtenerDocOtros',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postObtenerSaleContract(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/obtenerSaleContract',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGuardarTarifasNavieras(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/guardarTarifasNavieras', data)
                    .then(response => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('Error in fetchGuardarTarifasNavieras'))
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposConceptos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tiposConceptos')
                    .then(response => {
                        commit('setTiposConceptos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Exportaciones 2022 - ??
        fetchTerminoPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/terminosPago')
                    .then(response => {
                        commit('setTerminoPago', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //segmentos
        fetchSegmento({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/segmento')
                    .then(response => {
                        commit('setSegmento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPlazoPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/plazosPago')
                    .then(response => {
                        commit('setPlazoPago', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFormaPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/formasPago')
                    .then(response => {
                        commit('setFormaPago', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchBancoPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/bancosPango')
                    .then(response => {
                        commit('setBancoPago', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTerminoNegociacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/terminosNegociacion')
                    .then(response => {
                        commit('setTerminoNegociacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFormaNegociacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/formaNegociacion')
                    .then(response => {
                        commit('setFormaNegociacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGrupoEconomico({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/gruposEconomicos')
                    .then(response => {
                        commit('setGrupoEconomico', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchClienteExterior({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/clientesExterior')
                    .then(response => {
                        commit('setClienteExterior', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchComisionista({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/comisionistas')
                    .then(response => {
                        commit('setComisionista', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsignatario({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consignatarios')
                    .then(response => {
                        commit('setConsignatario', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchNotificador({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/notificadores')
                    .then(response => {
                        commit('setNotificador', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturador({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/facturadores')
                    .then(response => {
                        commit('setFacturador', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSecuencialProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/secuencialProforma', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCambioSecuencial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/cambioSecuencial', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCambioSecuencialInterna(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/cambioSecuencialInterna', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateFichaCliente(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearFichaCliente', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateFichaCliente(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarFichaCliente', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFichasClientes(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getFichasCliente', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchConsultarFicha(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarFicha', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsignatariosXcliente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consignatariosXcliente', {
                        params: data,
                    })
                    .then(response => {
                        commit('setConsignatariosXcliente', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarClienteLienaNaviera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarFichaClienteLinea', {
                        params: data,
                    })
                    .then(response => {
                        commit('setfichaClienteLineaNaviera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarBooking', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fechtGetFacturaXBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getFacturaFXBooking', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchConsultarBookingDetail(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarBookingDetail', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/anularBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReverseBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reverseBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchApproveBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/approveBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarGuiaRemision(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/aprobarGuiaRemision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchValidarBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/validarBooking', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        crearProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearProforma', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarProforma', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarProformaMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarProformaMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearEspecificacionPlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearEspecificacionPlanta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarEstadoProforma', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthFichasPanacea() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getFichasPanacea')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarSegmento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/guardarSegmento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postUpdateSegmento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateSegmento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postRemoveSegmento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeSegmento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // fecthFichasPanacea(_a) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/exportaciones/getFichasPanacea')
        //             .then(response => {
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        fecthPlantillas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getPlantillas', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthAlertasCorreo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getAlertasCorreo', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthCorreosEnviados(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getCorreosEnviados', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthPrevisualizarArchivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/previsualizarDocEmbarque',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthCorreosNoEnviados(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getCorreosNoEnviados', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthAlertaConfiguracion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getAlertaConfiguracion', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthCreateAlertaConfiguracion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearAlertaConfiguracion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthActualizarAlertaConfiguracion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarAlertaConfiguracion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConfigCorreoFact(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configCorreoFact', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fecthPrevisualizarProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/previsualizarProformaPG',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoFechaTarifa({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoFechaTarifa')
                    .then(response => {
                        commit('setTipoFechaTarifa', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarProformas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarProformas', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarProformasPaginacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarProformasPaginacion', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarProformaNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarProformaNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVehiculos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/vehiculo')
                    .then(response => {
                        commit('setVehiculos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFactura({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/factura', { params: data })
                    .then(response => {
                        commit('setFactura', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateVehiculo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createVehiculo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateVehiculo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateVehiculo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveVehiculo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeVehiculo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoExportacion() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getTipoEmbarque')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGenerarExcel(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getGenerarExcel', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTipoVehiculo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createTipoVehiculo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTipoVehiculo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateTipoVehiculo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTipoVehiculo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeTipoVehiculo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // fetchCreateVehiculo({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/exportaciones/createVehiculo', data)
        //             .then(response => {
        //                 resolve(response.data)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        // fetchUpdateVehiculo({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/exportaciones/updateVehiculo', data)
        //             .then(response => {
        //                 resolve(response.data)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        // fetchRemoveVehiculo({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/exportaciones/removeVehiculo', data)
        //             .then(response => {
        //                 resolve(response.data)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        fetchEntidadesXcategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/entidadesXcategoria', { params: data })
                    .then(response => {
                        commit('setEntidadesXcategoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEntidadesXcategoriaV2({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/entidadesXcategoriaV2', { params: data })
                    .then(response => {
                        commit('setEntidadesXcategoriaV2', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTransportadora(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createTransportadora', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTransportadora(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateTransportadora', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTransportadoras({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transportadoras')
                    .then(response => {
                        commit('setTransportadoras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTransportadora(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeTransportadora', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTiposVehiculo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tiposVehiculo')
                    .then(response => {
                        commit('setTiposVehiculo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPlantasRelacionadas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/plantasRelacionadas', { params: data })
                    .then(response => {
                        commit('setPlantasRelacionadas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateConductor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createConductor', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveConductor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeConductor', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConductores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/conductores')
                    .then(response => {
                        commit('setConductores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateConductor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateConductor', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchLoadTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/loadTarifa', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPesoBruto({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/pesoBruto')
                    .then(response => {
                        commit('setPesoBruto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateTarifa', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchApproveTarifaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/approveTarifaNaviera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReverseCancelTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reverseTarifaNaviera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDownloadProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/descargarProforma',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDownloadCobro(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/descargarCobro',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDownloadCierreDiario(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/descargarCierreDiario',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDownloadOrdenProduccion(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/descargarOrdenProduccion',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePesoBruto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createPesoBruto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePesoBruto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updatePesoBruto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemovePesoBruto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removePesoBruto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAseguradoras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/aseguradoras', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAseguradoras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Firmas Documentos
        fetchAllFirmasDocumentos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/getAllFirmasDocumentos', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllFirmasDocumentos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateFirmaDocumentos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        // "/api/auth/exportaciones/createPesoBruto",
                        '/api/auth/exportaciones/configuracion/createFirmaDocumentos',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateFirmaDocumentos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        // "/api/auth/exportaciones/updatePesoBruto",
                        '/api/auth/exportaciones/configuracion/updateFirmaDocumentos',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveFirmaDocumentos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/configuracion/removeFirmaDocumentos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Firmas Documentos
        fetchCreateAseguradora(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createAseguradora', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateAseguradora(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateAseguradora', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveAseguradora(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeAseguradora', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPuertosAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/puertosAll')
                    .then(response => {
                        commit('setPuertosAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchBuquesAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/buquesAll')
                    .then(response => {
                        commit('setBuquesAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSegmentosAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/segmentosAll')
                    .then(response => {
                        commit('setSegmentosAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAgenciaNavieraAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/agenciaNavieraAll')
                    .then(response => {
                        commit('setAgenciaNavieraAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLineaNavieraAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/lineaNavieraAll')
                    .then(response => {
                        commit('setLineaNavieraAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEntidades(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/entidades', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchJefePlantaAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/jefePlantaAll', {
                        params: data,
                    })
                    .then(response => {
                        commit('setJefePlantaAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateJefePlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearJefePlanta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateJefePlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateJefePlanta', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchMatchJefePlantaEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/matchJefePlanta', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRemoveJefePlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/removeJefePlanta', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoContenedorAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoContenedorAll')
                    .then(response => {
                        commit('setTipoContenedorAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTerminalEmbarqueAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/terminalEmbarqueAll')
                    .then(response => {
                        commit('setTerminalEmbarqueAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTransportadorasAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transportadorasAll')
                    .then(response => {
                        commit('setTransportadorasAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPesoBrutoAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/pesoBrutoAll')
                    .then(response => {
                        commit('setPesoBrutoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTiposVehiculoAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tiposVehiculoAll')
                    .then(response => {
                        commit('setTiposVehiculoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVehiculosAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/vehiculoAll')
                    .then(response => {
                        commit('setVehiculosAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConductoresAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/conductoresAll')
                    .then(response => {
                        commit('setConductoresAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPaisesSRI({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/paisesSRI')
                    .then(response => {
                        commit('setPaisesSRI', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPaisesXMercado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarPaisesXMercado', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setfichaClienteLineaNaviera", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCiudadesProvXpais({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/ciudadesProvXpais', { params: data })
                    .then(response => {
                        commit('setCiudadesProvXpais', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPuertosXPais(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarPuertosXPais', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setfichaClienteLineaNaviera", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCiudadXPais(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCiudadXPais', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setfichaClienteLineaNaviera", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmbarquesAprobados({ commit }, data) {
            return new Promise((resolve, reject) => {
                if (data.descargar) {
                    axios({
                        method: 'get',
                        url: '/api/auth/exportaciones/embarquesAprobados',
                        responseType: 'blob',
                        params: data,
                    })
                        .then(response => {
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                            console.error(error)
                        })
                } else {
                    axios
                        .get('/api/auth/exportaciones/embarquesAprobados', {
                            params: data,
                        })
                        .then(response => {
                            commit('setEmbarquesAprobados', response.data)
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                }
            })
        },
        fecthConsultarAnticipos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarAnticipos', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Concepto Tarifa
        fetchAllConceptoTarifa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getAllConceptoTarifa', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllConceptoTarifa', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateConceptoTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/createConceptoTarifa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateConceptoTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        // "/api/auth/exportaciones/updatePesoBruto",
                        '/api/auth/exportaciones/mantenimiento/updateConceptoTarifa',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveConceptoTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/removeConceptoTarifa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Concepto Tarifa
        // Tipo Concepto
        fetchTipoConcepto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/getTipoConcepto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTipoConcepto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAllTipoConcepto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/getAllTipoConcepto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllTipoConcepto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateTipoConcepto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        // "/api/auth/exportaciones/createPesoBruto",
                        '/api/auth/exportaciones/configuracion/createTipoConcepto',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateTipoConcepto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        // "/api/auth/exportaciones/updatePesoBruto",
                        '/api/auth/exportaciones/configuracion/updateTipoConcepto',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveTipoConcepto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/configuracion/removeTipoConcepto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Tipo Concepto
        fecthEnviarProduccion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/enviarProduccion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthEnviarCorreoProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/enviarCorreoProforma', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Factura Fiscal
        fetchFacturasComercialesAprobadas({ commit }, data) {
            return new Promise((resolve, reject) => {
                if (data.descargar) {
                    axios({
                        method: 'get',
                        url: '/api/auth/exportaciones/transacciones/facturasComercialesAprobadas',
                        responseType: 'blob',
                        params: data,
                    })
                        .then(response => {
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                } else {
                    axios
                        .get('/api/auth/exportaciones/transacciones/facturasComercialesAprobadas', {
                            params: data,
                        })
                        .then(response => {
                            commit('setFacturasComercialesAprobadas', response.data)
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                }
            })
        },
        // Factura Fiscal
        fecthRecibero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/reciberos', { params: data })
                    .then(response => {
                        commit('setRecibero', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchContactoComercial({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/contactosComercial', { params: data })
                    .then(response => {
                        commit('setContactoComercial', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUsaAgent({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/usaAgents', { params: data })
                    .then(response => {
                        commit('setUsaAgent', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchBroker({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/brokers', { params: data })
                    .then(response => {
                        commit('setBroker', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthTipoDescuento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoDescuentos', { params: data })
                    .then(response => {
                        commit('setTipoDescuento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthTipoAnticipo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoAnticipos', { params: data })
                    .then(response => {
                        commit('setTipoAnticipo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthTipoExcedente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tipoExcedentes', { params: data })
                    .then(response => {
                        commit('setTipoExcedente', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreatePlantaRelacionada(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/createPlantaRelacionada', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePlantaRelacionada(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/updatePlantaRelacionada', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDeletePlantaRelacionada(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/deletePlantaRelacionada', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        createConfiguracionPlantaUsuario(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/configuracion/createConfiguracionPlantaUsuario', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConfiguracionPlantaUsuario(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/configuracionPlantaUsuario', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePlanBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearPlanBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarCobros(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCobros', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarCobroNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCobroNumDoc', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarDocumentosCobrados(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCobroDocumento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthConsultarFacturaAnticipos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarFacturaAnticipos', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearCobro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearCobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarCobro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarCobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarCobroDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarCobroDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarFacturaAnticipo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarFacturaAnticipo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoCobro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarEstadoCobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarCobroMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarCobroMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarPlanBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaPlanBooking', {
                        params: data,
                    })
                    .then(response => {
                        //commit('setConsultarPlanB', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarPlanBookingDetalle(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaPlanBookingDetalle', {
                        params: data,
                    })
                    .then(response => {
                        //commit('setConsultarPlanB', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // DistritoAduanero
        fetchAllDistritoAduanero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getAllDistritoAduanero', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllDistritoAduanero', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDistritoAduanero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getDistritoAduanero', {
                        params: data,
                    })
                    .then(response => {
                        commit('setDistritoAduanero', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateDistritoAduanero(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/createDistritoAduanero', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDistritoAduanero(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/updateDistritoAduanero', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveDistritoAduanero(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/removeDistritoAduanero', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthProformaNumDocFc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/obtenerProformaNumDocFc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearFacturaComercial', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarFacturaComercial', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarGeneralFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarGeneralFacturaComercial', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarSellosFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarSellosFacturaComercial', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarEstadoFacturaComercial', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarFacturaComercialMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarFacturaComercialMasivo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarPlantillaFC(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarPlantillaFC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturaComercialDocumentacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/auth/exportaciones/transacciones/facturas-comerciales/${data.id_factura}/documentacion/${data.id_documentacion_factura}`,
                        { params: data }
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasXdocumentar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/facturas-comerciales/obtenerFacturasXdocumentar', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasXdocumentar', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasDocumentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/facturas-comerciales/obtenerFacturasDocumentacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasDocumentacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteFacturasDocumentacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/facturas-comerciales/reporteFacturasDocumentacion', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoDocumentacionFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/exportaciones/transacciones/facturas-comerciales/modificarEstadoDocumentacionFactura',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAllFacturaComercialReporte(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/transacciones/facturas-comerciales/reporte/${data.tipo_reporte}`, {
                        params: data,
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasComerciales({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/obtenerFacturasComerciales', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasComerciales', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasComercialesDetalles(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/obtenerFacturasComercialesDetalles', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturaComercialNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/facturaComercialNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthPrevisualizarFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/transacciones/previsualizarFacturaComercial',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fecthPrevisualizarFacturaFiscal(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/transacciones/previsualizarFacturaFiscal',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // fecthPrevisualizarFacturaComercial({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios({
        //             method: 'post',
        //             url: '/api/auth/exportaciones/transacciones/previsualizarFacturaComercial',
        //             responseType: 'blob',
        //             data: data,
        //         })
        //             .then(response => {
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        fecthDownloadFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/descargarFacturaComercial',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthEnviarCorreoFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/enviarCorreoFacturaComercial', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthEnviarCorreoFacturaFiscal(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/enviarCorreoFacturaFiscal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthEnviarProduccionFacturaComercial(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/enviarProduccionFC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarEnviarCorreoFC(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/aprobarEnviarFC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarEnviarFcMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/aprobarEnviarFcMasivo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        verificarDataGeneralFC(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/verificarDataGeneralFC', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //Peso Bruto
        crearFacturaPesoBruto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearFacturaPesoBruto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturaPesoBrutoNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/facturaPesoBrutoNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasPesoBrutoSSR({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/obtenerFacturasPesoBrutoSSR', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasPesoBrutoSSR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarFacturaPesoBruto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarFacturaPesoBruto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoFacturaPesoBruto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarEstadoFacturaPesoBruto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //Factura Fiscal
        crearFacturaFiscal(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearFacturaFiscal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearFacturaFiscalAutomatico(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearFacturaFiscalAutomatico', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasFiscales({ commit }, data) {
            return new Promise((resolve, reject) => {
                if (data.descargar) {
                    axios({
                        method: 'get',
                        url: '/api/auth/exportaciones/transacciones/obtenerFacturasFiscales',
                        responseType: 'blob',
                        params: data,
                    })
                        .then(response => {
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                } else {
                    axios
                        .get('/api/auth/exportaciones/transacciones/obtenerFacturasFiscales', {
                            params: data,
                        })
                        .then(response => {
                            commit('setFacturasFiscales', response.data)
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                }
            })
        },
        fetchFacturaFiscalNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/facturaFiscalNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarFacturaFiscal(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarFacturaFiscal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoFacturaFiscal(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarEstadoFacturaFiscal', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarFacturaFiscalMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarFacturaFiscalMasivo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        verificarClaveAccesoFF(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/verificarClaveAccesoFF', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        verificarValidarFF(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/verificarValidarFF', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDownloadXmlFF(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/transacciones/descargarXmlFF',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // DistritoAduanero
        fetchCorreosProduccion() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/correosProduccion', {})
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCorreoProformas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/correosProforma', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCorreoFacturas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/correosFactura', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCorreoDocumentacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/correosDocumentacion', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdatePlanBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updatePlanBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchValidarBookingPlanifiacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/validarBookingplanificacion', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchValidarListBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/validarListBooking', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchCiudadesXPuerto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getCiudadesXPuerto', {
                        params: data,
                    })
                    .then(response => {
                        commit('setCiudadesXPuerto', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchCreateCiudadesXPuerto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/createCiudadesXPuerto', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateCiudadesXPuerto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/updateCiudadesXPuerto', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDeleteCiudadesXPuerto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/deleteCiudadesXPuerto', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTerminalEmbarqueXPuerto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getTerminalEmbarqueXPuerto', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setfichaClienteLineaNaviera", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMotivoNC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/motivoNC', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMotivoNC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMotivoND({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/motivoND', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMotivoND', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarNotaCredito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarNotasCredito', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarNotaDebito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarNotaDebito', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarNotaCreditoNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarNotaCreditoNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarNotaDebitoNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarNotaDebitoNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearNotaCredito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearNotaCredito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearNotaDebito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearNotaDebito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObtenerZipCode(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/obtenerZipCode', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObtenerDireccionEntrega(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/obtenerDireccionEntrega', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarNotaCredito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarNotaCredito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarNotaDebito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarNotaDebito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoNotaCredito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarEstadoNotaCredito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoNotaDebito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarEstadoNotaDebito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Certificados Exportacion
        fetchCertificadosExportacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/obtenerCertificadosExportacion', { params: data })
                    .then(response => {
                        commit('setCertificadosExportacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasComercialesSSR({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/obtenerFacturasComercialesSSR', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasComercialesSSR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasComercialesCert({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/obtenerFacturasComercialesCert', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasComercialesCert', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCertificadoExportacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/exportaciones/informes/obtenerCertificadoExportacion',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGenerarExcelCertificado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/generarExcelCertificado', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Certificados Exportacion
        // Dashboard Ventas
        fetchDashboardsVentas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/obtenerDashboardsVentas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setDashboardsVentas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Dashboard Ventas
        fetchConsultarCierreDiario(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCierres', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarCierreNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCierreNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearCierreDiario(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/crearCierreDiario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarCierreDiario(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarCierreDiario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoCierreDiario(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarEstadoCierreDiario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtUpdateDatesBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateDatesBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCiudadXPuerto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultarCiudadXPuerto', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarNotaCreditoMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarNotaCreditoMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarNotaDebitoMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/modificarNotaDebitoMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtObtnerDetallesBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/DetallesdeBookings', { params: data })
                    .then(response => {
                        //commit('setBookingDetalle', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtSearchDetallesBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/searchDetallesBooking', { params: data })
                    .then(response => {
                        //commit('setBookingDetalle', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnularDetalleBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/anularDetallesBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetSubLinea(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/sub_lineas', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/obtener_proformas', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtConsultarSeguimientoETA(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarSeguimientoETA', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtConsultarSeguimientoETAAll(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarSeguimientoETAAll', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSeguimientoAmerica(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSeguimientoAmerica', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSeguimientoAmericaMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSeguimientoAmericaMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSeguimientoAsia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSeguimientoAsia', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSeguimientoAsiaMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSeguimientoAsiaMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSeguimientoEuropa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSeguimientoEuropa', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSeguimientoEuropaMasivo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSeguimientoEuropaMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionSaldoProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/actualizarSaldoProforma', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtGetYearMonthFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/obtenerYearMonth', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtEmbarqueNoExportado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/embarqueNoExportado', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtObtenerLbsFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/lbsFacturadasporMercado', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtEmbarqueNoExportadoNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/embarqueNoExportadorNumDoc', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCrearEmbarqueNoExportado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearEmbarqueNoExportado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteLbsFacturadas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reporteLbsFacturadas', data, { responseType: 'arraybuffer' })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObtenerPaisesFacturaPorMercado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/paisesDeFacturasPorMercado', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObtenerPaisesFacturaPorMercadoTropack(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/paisesDeFacturasPorMercadoTropack', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObtenerClientesTropack(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/clientesDeFacturasTropack', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarCierrePresidencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/cierrePresidencia', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarCierrePresidenciaNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/cierrePresidenciaNumDoc', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearCierrePresidencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearCierrePresidencia', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarCierrePresidencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarCierrePresidencia', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoCierrePresidencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarCierrePresidenciaEstado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDownloadCierrePresidencia(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/descargarCierrePresidencia',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtUpdateDatesBookingDetalles(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateDatesBookingDetalles', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateDireccionEntrega(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createDireccionEntrega', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLibrasDetalladasFC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/obtenerLibrasDetalladasFC', {
                        params: data,
                    })
                    .then(response => {
                        commit('setFacturasComercialesSSR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDireccionEntrega(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateDireccionEntrega', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteLbsDetalladas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/reporteLbsDetalladasFC', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDeleteDireccionEntrega(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/deleteDireccionEntrega', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteDireccionesEntrega(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reporteDireccionEntrega', data, { responseType: 'arraybuffer' })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Documento
        fetchAllDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/documentos', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllDocumento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/configuracion/documentos/${data.id_documento}`, {
                        params: data,
                    })
                    .then(response => {
                        // commit("setDocumento", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultaDocumentos(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/configuracion/Alldocumentos`, {
                        params: data,
                    })
                    .then(response => {
                        // commit("setDocumento", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAllDocumentoReporte(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/configuracion/documentos/reporte/${data.tipo_reporte}`, {
                        params: data,
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/exportaciones/configuracion/documentos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/exportaciones/configuracion/documentos/${data.id_documento}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveDocumento(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/exportaciones/configuracion/documentos/${data.id_documento}`, { data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Documento
        //GenerarDocumentos
        generarDocumentosFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/configuracion/generarDocumentosFactura', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //GenerarDocumentos
        // InfiniteScroll
        fetchInfiniteScrollPaises({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/tributacion/configuracion/paises', {
                        params: data,
                    })
                    .then(response => {
                        commit('setInfiniteScrollPaises', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // InfiniteScroll
        // UsersByCompanyAplication
        fetchUsersByCompanyAplication({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/usuarios', {
                        params: data,
                    })
                    .then(response => {
                        commit('setUsersByCompanyAplication', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // UsersByCompanyAplication
        //Reporte Guia de Remision
        fetchReporteGuiaRemision(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reporteGuiaRemision', data, { responseType: 'arraybuffer' })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnticiposProforma(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarAnticiposProforma', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtGetFacturaXTarifaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getFacturaFXTarifanaviera', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDeletePlanBooking(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/deletePlanBooking', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Courier
        fetchAllCourier({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/couriers', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllCourier', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCourier(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/mantenimiento/couriers/${data.id_courier}`, {
                        params: data,
                    })
                    .then(response => {
                        // commit("setCourier", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAllCourierReporte(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/mantenimiento/couriers/reporte/${data.tipo_reporte}`, {
                        params: data,
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fechtObtenerLbsFacturaTropack(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/lbsFacturadasTropack', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMonitorEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/monitorEmbarque', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMonitorEmbarque', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMonitorDocumentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/monitor-documentacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMonitorDocumentacion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateCourier(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/exportaciones/mantenimiento/couriers', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateCourier(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/exportaciones/mantenimiento/couriers/${data.id_courier}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveCourier(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/exportaciones/mantenimiento/couriers/${data.id_courier}`, { data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Courier
        fetchModificacionEmbarqueNoExportado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarEmbarqueNoExportado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificacionEstadoEmbarqueNoExportado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarEstadoEmbarqueNoExportado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchObtenerGuiaRemisionId(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/obtenerGuiaRemision', { params: data })
                    .then(response => {
                        //commit('setConsultaEmbarque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreatePlanificacionReserva(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createPlanificacionReserva', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // DocumentacionEmbarque
        fetchCreateDocumentacionFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/exportaciones/transacciones/facturas-comerciales/crearDocumentacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDocumentacionFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/exportaciones/transacciones/facturas-comerciales/modificarDocumentacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarEstadoDocumentacionDetalle(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/exportaciones/transacciones/facturas-comerciales/modificarEstadoDocumentacionDetalle',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarMasivoEstadoDocumentacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/exportaciones/transacciones/facturas-comerciales/modificarMasivoEstadoDocumentacion',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarMasivoEstadoDocumentacionDetalle(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/exportaciones/transacciones/facturas-comerciales/modificarMasivoEstadoDocumentacionDetalle',
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEnviarCorreoDocumentacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/facturas-comerciales/enviarCorreoDocumentacion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRemoveDocumentacionEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(
                        `/api/auth/exportaciones/tansacciones/facturas-comerciales/documentacion/${data.id_documentacion_embarque}`,
                        { data }
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // DocumentacionEmbarque
        //Contrato
        fetchPaginationContratos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/paginateContratos', { params: data })
                    .then(response => {
                        commit('setPaginationContratos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchContratos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/contratos', { params: data })
                    .then(response => {
                        commit('setContratos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchContrato({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/contrato', { params: data })
                    .then(response => {
                        commit('setContrato', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCrearContrato(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/crearContrato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePlanificacionReserva(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updatePlanificacionReserva', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarContrato(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/modificarContrato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetPlanificacionReserva(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getPlanificacionReserva', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnularPlanificacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/anularPlanificacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarEstadoContrato(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/modificarEstadoContrato', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarPlanificacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/aprobarPlanificacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //Contrato
        fetchCrearModificarProformaAdjunto(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/crearModificarProformaAdjunto', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReversarPlanificacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/reversarPlanificacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPlanificacionEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getPlanificacionEmbarque', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGuardarBookingPlanificacion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/saveBookingPlanificacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPrevisualizarProformaAdjunto(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/previsualizarProformaAdjunto',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetTarifasReservas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/tarifasReservas', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtCreateEmbarqueSello(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/createEmbarqueSello', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtUpdateEmbarqueSello(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateEmbarqueSello', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // FichaClienteExterior
        fetchAllFichaClienteExterior({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/ficha-cliente-exterior', {
                        params: data,
                    })
                    .then(response => {
                        commit('setAllFichaClienteExterior', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // FichaClienteExterior
        fechtUpdateDatesReserva(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateDatesReserva', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // FichaClienteExterior
        //ParametroConfigExpo
        fetchParametroConfigExpo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/configuracion/parametroConfigExpo', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProformasSalem(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getProformas', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTotalExportacionAnual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/facturas-comerciales/totalExportacionAnual', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTotalExportacionAnual', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteTotalExportacionAnual(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/facturas-comerciales/reporteTotalExportacionAnual', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/embarque/modificarEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateStatusEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/embarque/modificarEstadoEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateSelloEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/embarque/modificarSelloEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateEmbarqueFacturado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/embarque/modificarEmbarqueFacturado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPrevisualizarCartaDespacho(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/embarque/previsualizarCartaDespacho',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPrevisualizarGuiaRemision(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/embarque/previsualizarGuiaRemision',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateCargaNoExportada(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/embarque/updateCargaNoExportada', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //Embarque
        fetchExportacionConfiguracion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/configuraciones/configuracion/`, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchExportacionConfiguracionParametro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/configuracion/configuracion/${data.parametro}`, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchExportacionConfiguracionRangoParametro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/configuracion/configuracion_rango/${data.parametro}`, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarLbsReales(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarLbsReales', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setTotalExportacionAnual", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarLbsRealesAll(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarLbsRealesAll', {
                        params: data,
                    })
                    .then(response => {
                        //commit("setTotalExportacionAnual", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarPolizas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarFacturaPoliza', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarPolizasAll(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/consultarFacturaPolizaAll', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarFacturaPolizas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/informes/modificarFacturaPoliza', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePoliza(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/modificarPoliza', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetTarifaNaviera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getTarifaNaviera', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetBookingEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getBookingEmbarque', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetPreAprobacionFF(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getPreAprobacionFF', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPostPreAprobacionFF(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/postPreAprobacionFF', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatePreAprobacionFF(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updatePreAprobacionFF', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDeclararPolizaCredito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/declararPolizaCredito', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasComercialesPDF(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/descargarFacturasComercialesPDF',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturaPolizaResumen(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/consultarFacturaPolizaResumen', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFacturasFiscalesPDF(_a, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/auth/exportaciones/transacciones/descargarFacturasFiscalesPDF',
                    responseType: 'blob',
                    params: data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetUserEmail(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getUserEmail', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetBlade(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/obtenerBlade`, {
                        params: data,
                    })
                    .then(response => {
                        // commit("setDocumento", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Factura Poliza
        fetchConsultarPolizaCredito(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/exportaciones/informes/facturas-polizas/consultarPolizaCredito`, {
                        params: data,
                    })
                    .then(response => {
                        // commit("setDocumento", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetAlertaCorreo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/getAlertaCorreo', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarPolizaCreditoReporte(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/auth/exportaciones/informes/facturas-polizas/consultarPolizaCredito/reporte/${data.tipo_reporte}`,
                        { params: data, responseType: 'arraybuffer' }
                    )
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPrecioRetornoFinca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/informes/precioRetornoFinca', { params: data })
                    .then(response => {
                        commit('setPrecioRetornoFinca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPostAlertaCorreo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/postAlertaCorreo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarSaldosClientesFacturas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/consultaSaldosClientesFacturas', { params: data })
                    .then(response => {
                        // commit('setConsultaSaldosClientes', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCruceAnticipoFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/cruce-anticipo/getCruce', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCruceAnticipoFacturaDetalle(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/cruce-anticipo/getCruceDetalle', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCruceAnticipoFacturaNumDoc(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/cruce-anticipo/getCruceNumDoc', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateCruceAnticipoFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/cruce-anticipo/createCruce', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateCruceAnticipoFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/cruce-anticipo/updateCruce', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateStatusCruceAnticipoFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/cruce-anticipo/updateStatusCruce', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMonitorContenedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/monitorContenedores', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMonitorContenedores', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDetalleContenedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/detalleContenedores', {
                        params: data,
                    })
                    .then(response => {
                        commit('setDetalleContenedores', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMonitorOrdenesPedido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/monitorOrdenesPedido', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMonitorOrdenesPedido', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDetallePrecioFinca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/detallePrecioFinca', {
                        params: data,
                    })
                    .then(response => {
                        commit('setDetallePrecioFinca', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMonitorOrdenesPedidoFc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/monitorOrdenesPedidoFc', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMonitorOrdenesPedidoFc', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDetallePrecioFincaFc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/detallePrecioFincaFc', {
                        params: data,
                    })
                    .then(response => {
                        commit('setDetallePrecioFincaFc', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProformaDetallePrecioFinca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/proformaDetallePrecioFinca', {
                        params: data,
                    })
                    .then(response => {
                        commit('setProformaDetallePrecioFinca', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchYearToYear({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/year-to-year', {
                        params: data,
                    })
                    .then(response => {
                        commit('setYearToYear', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPrecioPorSemana({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/dashboard/precio-por-semana', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPrecioPorSemana', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSectores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/sectores')
                    .then(response => {
                        commit('setSectores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSectoresXmercado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/sectoresXmercado', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSectoresXmercado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fechtUpdateReservasAsignadas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/updateReservasAsignadas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsultarFacturasTarifa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/obtenerFacturasTarifas', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetResponsablePlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getResponsablePlanta', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtGetDocLogistica(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getDocumentoLogistica', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchConsultarTarifasEmbarque(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/transacciones/obtenerTarifasEmbarque', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetEntidadResponsable(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getEntidadResponsable', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtReporteLogistica(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/reporteLogistica', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fechtUpdateTarifaFactura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/transacciones/reasignarTarifaNaviera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetResponsable(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/mantenimiento/getResponsableNombre', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtDescargaDocLogistica(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/descargarGre', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fechtPostResponsblePlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/postResponsablePlanta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fechtUpdateResponsblePlanta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/exportaciones/mantenimiento/updateResponsablePlanta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProformasGeneralesSalem(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getProformasGeneral', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGetReservasProformas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/getReservasProforma', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSaldoProformaGeneral(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/exportaciones/saldo/proforma_general', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
